import { glass } from "./glass";

/**
 * Spatial surface fills + chip borders.
 *
 * Chip idle border copied from ManuallyItems.js / ShoppingContent.js
 * ("1px solid rgba(218, 218, 218, 0.6)").
 * Chip selected border + fill derived from galleryChipGlassActiveSx
 * in LayoutVersionSlider.js (~292–296) — neutral black-alpha rim with
 * solid-ish white fill, no tenant tint.
 */
export const surface = {
  glass: glass.background,
  glassElevated: glass.backgroundElevated,
  glassSolid: glass.backgroundSolid,
  chipIdleBorder: "1px solid rgba(218, 218, 218, 0.6)",
  chipIdleBackground: "rgba(252, 252, 254, 0.99)",
  chipSelectedBorder: "1px solid rgba(0, 0, 0, 0.12)",
  chipSelectedBackground: "rgba(255, 255, 255, 0.99)",
};
